import { Button, Grid, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import { useFormContext } from 'react-hook-form';
import { useMemo } from 'react';
import { buttonStyle } from '../TransitionStyles';
import { saveInitialDueDiligenceForm } from '../../../../api/transitions';
import { trimData } from '../../../../utils/formatText';
import { enqueueSnackbar } from '../../../../reusable-components/snackbar';

InitialDueDiligenceSaveButton.propTypes = {
  setPortfolio: PropTypes.func,
  setIsAddingFacility: PropTypes.func,
};

export default function InitialDueDiligenceSaveButton({ setPortfolio, setIsAddingFacility }) {
  const navigate = useNavigate();
  const { id: portfolioId } = useParams();
  const [searchParams] = useSearchParams();
  const facilityId = searchParams.get('facilityId');

  const {
    handleSubmit,
    formState: { isDirty },
    watch,
  } = useFormContext();

  const watching = watch();

  const handleSave = async (data) => {
    try {
      const resp = await saveInitialDueDiligenceForm({
        id: portfolioId,
        data,
        sellerFacilityId: facilityId,
      });

      setPortfolio(resp.data);

      return {
        portfolioId: resp.data.id,
        facilityId: resp.data.facilityId,
      };
    } catch {
      enqueueSnackbar('Failed to update portfolio', { variant: 'error' });
      return {
        portfolioId,
        facilityId,
      };
    }
  };

  const onSubmit = async (data) => {
    const trimmedData = trimData(data);
    const { portfolioId: savedPortfolioId, facilityId: savedFacilityId } = await handleSave(trimmedData);

    if (facilityId === '0') {
      setIsAddingFacility(false);
    }

    navigate(`/dashboard/transitions/initial-due-diligence/${savedPortfolioId}?facilityId=${savedFacilityId}`, {
      replace: true,
    });
  };

  const areRequiredFieldsFilled = useMemo(
    () => !!(watching.facilityName && watching.portfolioName && watching.companyId),
    [watching]
  );

  const isSaveButtonDisabled = useMemo(() => !areRequiredFieldsFilled || !isDirty, [areRequiredFieldsFilled, isDirty]);

  const tooltipTitle = !areRequiredFieldsFilled ? 'Fill in required fields' : !isDirty ? 'No changes to save' : '';

  return (
    <Grid item>
      <Tooltip placement="left" arrow title={tooltipTitle} disableHoverListener={!tooltipTitle}>
        <span>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleSubmit(onSubmit)}
            disabled={isSaveButtonDisabled}
            fullWidth
            sx={{ ...buttonStyle }}
          >
            Save
          </Button>
        </span>
      </Tooltip>
    </Grid>
  );
}
